import { TaxRepository } from "../../domain/repositories/TaxRepository";
import {
  TaxSpecificationResultEntity,
  GSTDeterminationEntity,
  TDSRatesResultEntity,
} from "../../domain/entities/TaxEntity";
import {
  fetchTaxSpecification,
  fetchGSTTypeDetermination,
  fetchTDSRates,
} from "../api/taxApi";
import { TaxMapper } from "../mappers/TaxMapper";

export class TaxRepositoryImpl implements TaxRepository {
  async fetchTaxSpecification(
    specification: string
  ): Promise<TaxSpecificationResultEntity> {
    try {
      const response = await fetchTaxSpecification(specification);
      return TaxMapper.toTaxSpecificationResultEntity(response);
    } catch (error: any) {
      console.error("Error in TaxRepository.fetchTaxSpecification:", error);
      throw error;
    }
  }

  async fetchGSTTypeDetermination(
    invoiceData: any
  ): Promise<GSTDeterminationEntity> {
    try {
      const response = await fetchGSTTypeDetermination(invoiceData);
      return TaxMapper.toGSTDeterminationEntity(response);
    } catch (error: any) {
      console.error("Error in TaxRepository.fetchGSTTypeDetermination:", error);
      throw error;
    }
  }

  async fetchTDSRates(): Promise<TDSRatesResultEntity> {
    try {
      const response = await fetchTDSRates();
      return TaxMapper.toTDSRatesResultEntity(response);
    } catch (error: any) {
      console.error("Error in TaxRepository.fetchTDSRates:", error);
      throw error;
    }
  }
}

export const taxRepository = new TaxRepositoryImpl();

